import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["scrollLeft"]
const _hoisted_2 = { class: "onboarding-million-users__people" }
const _hoisted_3 = ["src"]

import { computed, ref } from 'vue'

import { getImage } from '@/models/onboarding'
import type { QuestionnaireView } from '@/models/onboarding'
import type { MillionUsersPage } from '@/models/onboarding.types'

import Rive from '@/app/components/Rive.vue'
import Layout from '../Layout.vue'
import MillionUsersTestimonial from '../MillionUsersTestimonial.vue'
import { platform } from '@/services/platform'


export default /*@__PURE__*/_defineComponent({
  __name: 'MillionUsers',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const riveRef = ref<InstanceType<typeof Rive> | null>(null)
const testimonialsRef = ref<InstanceType<typeof MillionUsersTestimonial>[]>([])

const finishedIntroAnimation = ref(false)

/**
 * Set the scroll position of the carousel
 * to the item matching the current subpage index.
 */
const testimonialsScrollPosition = computed(() => {
  if (testimonialsRef.value.length === 0) {
    return 0
  }
  const index = props.view.currentSubpageIndex
  const currentTestimonial = testimonialsRef.value[index]
  return currentTestimonial.$el.offsetWidth * (index + 1)
})

const page = computed(() => {
  return props.view.currentPage as MillionUsersPage
})

const rive = computed(() => {
  return riveRef.value?.rive
})

const reverseContentArray = computed(() => {
  return [...page.value.content].reverse()
})

function showTestimonials(): void {
  if (finishedIntroAnimation.value) {
    return
  }

  finishedIntroAnimation.value = true

  if (platform.isDesktopWidth()) {
    rive.value?.play('desktopZoom')
  } else {
    rive.value?.play('mobileZoom')
  }

  const delay = 2300
  setTimeout(() => {
    props.view.showContinueButton()
  }, delay)
}

function getTestimonialImage(image: string): string {
  return require(`@/assets.v2/images/${image}`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    class: _normalizeClass(["onboarding-million-users", {
      'onboarding-million-users--loaded': riveRef.value?.isLoaded,
      'onboarding-million-users--show-testimonials': finishedIntroAnimation.value,
    }]),
    title: page.value.title,
    subtitle: page.value.subtitle
  }, {
    default: _withCtx(() => [
      (finishedIntroAnimation.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "onboarding-million-users__testimonials",
            scrollLeft: testimonialsScrollPosition.value
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reverseContentArray.value, (person, index) => {
              return (_openBlock(), _createBlock(MillionUsersTestimonial, {
                ref_for: true,
                ref_key: "testimonialsRef",
                ref: testimonialsRef,
                key: person.name,
                image: getTestimonialImage(person.image),
                person: person,
                isActive: __props.view.currentSubpageIndex === index
              }, null, 8, ["image", "person", "isActive"]))
            }), 128))
          ], 8, _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.value.content, (person, index) => {
          return (_openBlock(), _createElementBlock("img", {
            key: person.name,
            src: getTestimonialImage(person.image),
            alt: "",
            width: "90",
            height: "90",
            class: "onboarding-million-users__person",
            style: _normalizeStyle({ '--popup-delay': index })
          }, null, 12, _hoisted_3))
        }), 128))
      ]),
      _createVNode(Rive, {
        ref_key: "riveRef",
        ref: riveRef,
        class: "onboarding-million-users__rive",
        src: _unref(getImage)(page.value.animation.src),
        fit: "Layout",
        onStop: showTestimonials
      }, null, 8, ["src"])
    ]),
    _: 1
  }, 8, ["class", "title", "subtitle"]))
}
}

})